module.exports = __webpack_public_path__ + "img/product_11.6b6404c.svg";